
















import {Component, Prop, Vue} from 'vue-property-decorator';
import {ActiveProvide} from "@/support/reactive"

export type TableCellClassification = 'normal'|'number';

/**
 * @status stable
 * @published 2.0.0
 * @changelog 2.0.0 Published.
 * @changelog 3.7.0 Add support for wrapping.
 * @changelog 4.11.0 Add icon support.
 */
@Component
export default class JdsTableCell extends Vue {
    @Prop({default: false, type: Boolean}) wrap!: boolean
    @Prop({default: false, type: Boolean}) primary!: boolean
    @Prop() icon!: string
    @ActiveProvide('jds.table.cell.classifier') classifier: Vue|null = null

    /**
     * Turn this cell into a link.
     */
    @Prop() to!: string

    classification: TableCellClassification = 'normal';

    beforeMount () {
        this.classifier = new Vue();
        this.classifier.$on('inform', (type: TableCellClassification) => {
            this.classification = type;
        })
    }

    get classes() {
        return {
            'jds-font-bold': this.primary,
            'jds-text-right': this.classification === 'number',
            'jds-whitespace-nowrap': !this.wrap,
            'jdsc-table-cell-wrap': this.wrap,
        }
    }
}
